import { Body3 } from '@flatsy/core/MaterialUi/Typo'
import { Typography } from '@material-ui/core'
import clsx from 'clsx'
import React from 'react'
import CheckIcon from '@material-ui/icons/Check'
import i18n from '@flatsy/utils/translations'
import { useStyles } from './Style'
import { IStep } from './Type'

const Step: React.FC<IStep> = ({ name, state, number, last }): React.ReactElement => {
  const classes = useStyles()
  const containerClasses = () => {
    const classesArray = [classes.container]
    if (state === 'completed') {
      classesArray.push(classes.completed)
    } else if (state === 'incomming') {
      classesArray.push(classes.incomming)
    } else if (state === 'inprogress') {
      classesArray.push(classes.inprogress)
    }
    return clsx(classesArray)
  }
  const statusText = () => {
    if (state === 'completed') {
      return i18n.t('finished')
    }
    if (state === 'incomming') {
      return i18n.t('next')
    }
    if (state === 'inprogress') {
      return i18n.t('in_progress')
    }
    return ''
  }
  return (
    <div className={containerClasses()}>
      <div className={classes.header}>
        <div className={classes.number}>
          <Body3 className={classes.numberLabel}>
            {state === 'completed' ? <CheckIcon className={classes.statusIcon} /> : number}
          </Body3>
        </div>
        <div>
          <Body3>{name}</Body3>
          <div className={classes.status}>
            <Typography className={classes.statusLabel} component="div">
              {statusText()}
            </Typography>
          </div>
        </div>
      </div>
      {!last && (
        <div className={classes.line}>
          <div className={classes.lineInner} />
        </div>
      )}
    </div>
  )
}

export default Step
